module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K26HQPH.c6c9e554.jpg";